import { render, staticRenderFns } from "./OtherInsurance.vue?vue&type=template&id=a1abc454"
import script from "./OtherInsurance.vue?vue&type=script&lang=js"
export * from "./OtherInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports